import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class RepTypeExt extends Mappeable {

    idTypeExternalReportPK: number;
    description: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            description: this.description,
            mrkActive: this.mrkActive,
        }
    }


}
